var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultData !== null)?_c('div',[_c('h2',{staticClass:"text-2xl"},[_vm._v("Respuesta: ")]),_c('vue-json-pretty',{attrs:{"data":_vm.resultData,"showDoubleQuotes":false,"showLength":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }